import { SeabornTheme } from "../.internal/themes/SeabornTheme";
export default SeabornTheme;